import MotorDetailsIcon from 'src/assets/RiskReport_images/motorDetailsIcon.svg'
import FireDetailsIcon from 'src/assets/RiskReport_images/fireDetailsIcon.svg'
import MarineDetailsIcon from 'src/assets/RiskReport_images/marineDetailsIcon.svg'
import GroupAccidentalIcon from 'src/assets/images/GroupAccidentalImage.svg'
import GroupTermIcon from 'src/assets/images/GroupTermImage.svg'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import Srikanth from 'src/assets/AddedServices/Srikanth.svg'
import Atmaram from 'src/assets/AddedServices/Atmaram.svg'
import Satish from 'src/assets/AddedServices/Satish.svg'
import HealthBridge from 'src/assets/AddedServices/HealthBridge.svg'
import Transaction from 'src/assets/CdBalance_Images/Transaction.svg'
import Calculator from 'src/assets/CdBalance_Images/Calculator.svg'
import Request from 'src/assets/CdBalance_Images/Request.svg'

export const TEMPLATE_FEATURES = {
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  PREMIUM_CLAIM_GRAPH: 'PREMIUM_CLAIM_GRAPH',
  CONTACT_US: 'CONTACT_US',
  KEY_SUGGESTIONS: 'KEY_SUGGESTIONS',
  UPCOMING_RENEWALS: 'UPCOMING_RENEWALS',
  PENDING_CLAIMS: 'PENDING_CLAIMS',
  KEY_DETAILS: 'KEY_DETAILS',
  TOTAL_VEHICLES: 'TOTAL_VEHICLES',
  AGE_GRAPH: 'AGE_GRAPH',
  TREND_ANALYSIS: 'TREND_ANALYSIS',
  COVERAGES: 'COVERAGES',
  AGGREGATES: 'AGGREGATES',
}

export const FIELD_TYPES_LIST = [
  {
    name: 'Number',
    value: 'NUMBER',
  },
  {
    name: 'Dropdown',
    value: 'DROPDOWN',
  },
  {
    name: 'Text',
    value: 'TEXT',
  },
]

export const FIELD_TYPES = {
  number: 'NUMBER',
  text: 'TEXT',
  dropDown: 'DROPDOWN',
  multiSelect: 'MULTI_SELECT',
}

export const PENDING_CLAIM_TYPES = {
  'Motor Insurance': null,
  'Group Term Insurance': 'EmployeeBenefitsClaims',
  'Group Accidental Insurance': 'groupAccidental',
}

export const DOWNLOAD_DOCUMENT_ICONS = {
  'Fire Insurance': FireDetailsIcon,
  'Motor Insurance': MotorDetailsIcon,
  'Marine Insurance': MarineDetailsIcon,
  [INSURANCE_NAMES.GROUP_TERM_INSURANCE]: GroupTermIcon,
  [INSURANCE_NAMES.GROUP_ACCIDENTAL_INSURANCE]: GroupAccidentalIcon,
}

export const POLICY_STATUS_TYPES = {
  active: 'ACTIVE',
  documentRequired: 'DOCUMENT_REQUIRED',
  expired: 'EXPIRED',
  inactive: 'INACTIVE',
  needMoreInfo: 'NEED_MORE_INFO',
  verificationPending: 'VERIFICATION_PENDING',
  digitalizing: 'DIGITALIZING',
  invalidDocument: 'INVALID_DOCUMENT',
  expiring: 'EXPIRING',
  renewed: 'RENEWED',
  renewalUnderDigitalizing: 'RENEWAL_UNDER_DIGITALIZING',
  underRenewal: 'UNDER_RENEWAL',
}

export const POLICY_STATUS_TYPE_ENUMS = {
  ACTIVE: 'Active',
  DOCUMENT_REQUIRED: 'Document Required',
  EXPIRED: 'Expired',
  INACTIVE: 'Inactive',
  NEED_MORE_INFO: 'Need More Info',
  VERIFICATION_PENDING: 'Verification Pending',
  DIGITALIZING: 'Digitalizing',
  INVALID_DOCUMENT: 'Invalid Document',
  EXPIRING: 'Expiring',
  RENEWAL_UNDER_DIGITALIZING: 'Renewal Under Digitalizing',
  UNDER_RENEWAL: 'Under Renewal',
}

export const ROLES = {
  CORPORATE_LEADER: 'CORPORATE_LEADER',
  CORPORATE_CEO: 'CORPORATE_CEO',
  CORPORATE_INDIVIDUAL: 'CORPORATE_INDIVIDUAL',
  CORPORATE: 'CORPORATE',
  CORPORATE_POC: 'CORPORATE_POC',
  CORPORATE_ADMIN: 'CORPORATE_ADMIN',
  RETAIL_INDIVIDUAL: 'RETAIL_INDIVIDUAL',
}

export const DASHBOARD_TABS = {
  COMPANY_POLICIES: 'COMPANY_POLICIES',
  PRODUCTS: 'PRODUCTS',
  RENEW: 'RENEW',
  CLAIM: 'CLAIM',
  MODIFICATIONS: 'MODIFICATIONS',
  YOUR_POLICIES: 'YOUR_POLICIES',
  BUYPOLICY: 'BUYPOLICY',
  CLAIM_ASSUREGUARD: 'CLAIM_ASSUREGUARD',
  UPCOMING_FEATURES: 'UPCOMING_FEATURES',
  VALUE_ADDED_SERVICES: 'VALUE_ADDED_SERVICES',
  INSURANCE_SPOTLIGHT: 'INSURANCE_SPOTLIGHT',
  BUYINSURANCE: 'BUYINSURANCE',
}

export const CLIENT_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
}

export const CLIENT_TYPE_SMALL_CASE = {
  INDIVIDUAL: 'individual',
  CORPORATE: 'corporate',
}

export const POLICY_TYPE = {
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY',
}

export const FIRE_INSURANCE_CATEGORIES = [
  ['Total', 'Premium'],
  ['Total', 'Claims'],
  ['Claims', 'Paid'],
  ['Claims', 'Outstanding'],
]

export const MARINE_INSURANCE_CATEGORIES = [
  ['Turnover', ''],
  ['Premium', 'Total'],
  ['Claims', 'Total'],
]

export const OTHER_INSURANCE_CATEGORIES = [
  ['Premium', 'Total'],
  ['Claims', 'Total'],
  ['Paid', 'Claims'],
  ['Outstanding', 'Claims'],
]

export const RENEWAL_TABS = {
  EXPIRED: 'EXPIRED',
  ACTIVE: 'ACTIVE',
  NEAR_TO_EXPIRE: 'NEAR_TO_EXPIRE',
}

export const GROUP_INSURANCE_LIST = [
  INSURANCE_NAMES.HEALTH_INSURANCE,
  INSURANCE_NAMES.GROUP_HEALTH_INSURANCE,
  INSURANCE_NAMES.GROUP_HEALTH_INSURANCE_PARENTS,
  INSURANCE_NAMES.GROUP_SUPER_TOP_UP_INSURANCE,
  INSURANCE_NAMES.GROUP_OPD_HEALTH_INSURANCE,
  INSURANCE_NAMES.GROUP_CRITICAL_ILLNESS_INSURANCE,
  INSURANCE_NAMES.GROUP_TOP_UP_INSURANCE,
]
export const FILE_CATEGORY = {
  'Risk Report': 'RISK_REPORT',
  Quote: 'QUOTES',
  RFQ: 'RFQ',
  Others: 'OTHERS',
}

export const USER_DETAILS_VALIDATIONS = {
  insuredPersonSelectionValidation:
    'Please select at least one insured person and enter age to continue.',
}

export const CONTACT = {
  Contact: '1800 3099 247',
}

export const TESTIMONIAL_DATA = [
  {
    id: 10001,
    detailsImage: Satish,
    additionalInsightText: // prettier-ignore
    'Satish\'s Additional Insight Factors Beyond Price.',
  },
  {
    id: 10002,
    detailsImage: Srikanth,
    additionalInsightText:// prettier-ignore
      'Srikanth\'s Additional Insight Factors Beyond Price.',
  },
  {
    id: 10003,
    detailsImage: Atmaram,
    additionalInsightText:// prettier-ignore
     'Atmaram\'s Additional Insight Factors Beyond Price.',
  },
  {
    id: 10004,
    detailsImage: HealthBridge,
    additionalInsightText: 'Additional Insight Factors Beyond Price.',
  },
]

export const SEARCH_PERSISTENCE_ACTION_TYPES = {
  setViewPolicyDashboardFilters: 'SET_VIEW_POLICY_DASHBOARD_FILTERS',
  setPolicyCitiesFilters: 'SET_POLICY_CITIES_FILTERS',
}
export const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli',
  'Daman and Diu',
  'Delhi',
  'Lakshadweep',
  'Puducherry',
]

export const CORPORATE_HEALTH_INSURANCE_LIST = [
  'Health Insurance',
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Group OPD Health Insurance',
  'Group Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
  'Group Term Life Insurance',
  'Employees Deposit Linked Insurance Scheme (EDLI)',
]

export const HEALTH_INSURANCE_LIST = [
  'Health Insurance',
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Super Top Up Insurance',
  'Top Up Insurance',
  'Group OPD Health Insurance',
  'Individual OPD Health Insurance',
  'Group Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
  'Critical Illness Insurance',
]

export const HEALTH_STATS_INSURANCE_LIST = [
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Group OPD Health Insurance',
  'Group Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
]

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
}

export const INSURANCE_NAME_TYPE = {
  MOTOR_INSURANCE: 'Motor Insurance',
  CAR_INSURANCE: 'Car Insurance',
  BIKE_INSURANCE: 'Bike Insurance',
}

export const MOTOR_INSURANCE_LIST = [
  INSURANCE_NAMES.MOTOR_INSURANCE,
  INSURANCE_NAMES.BIKE_INSURANCE,
  INSURANCE_NAMES.CAR_INSURANCE,
]

export const VALUE_ADDED_SERVICES_TABS = {
  BUY_A_NEW_CAR_BIKE: 'BUY_A_NEW_CAR_BIKE',
  MARRIAGE_NEWBORN: 'MARRIAGE_NEWBORN',
  HOME_LOAN: 'HOME_LOAN',
  TROVITY_ONE_CARD: 'TROVITY_ONE_CARD',
  TRAVEL_PLANS: 'TRAVEL_PLANS',
}

export const VALUE_ADDED_SERVICES_TAB_LIST = [
  {
    type: VALUE_ADDED_SERVICES_TABS.BUY_A_NEW_CAR_BIKE,
    isDisabled: false,
  },
  {
    type: VALUE_ADDED_SERVICES_TABS.MARRIAGE_NEWBORN,
    isDisabled: false,
  },
  {
    type: VALUE_ADDED_SERVICES_TABS.HOME_LOAN,
    isDisabled: true,
  },
  {
    type: VALUE_ADDED_SERVICES_TABS.TROVITY_ONE_CARD,
    isDisabled: true,
  },
  {
    type: VALUE_ADDED_SERVICES_TABS.TRAVEL_PLANS,
    isDisabled: true,
  },
]

export const POLICY_UPLOAD_METHOD = {
  manual: 'MANUAL',
  direct: 'DIRECT',
}

export const CLAIM_GRAPH_TYPE_LABELS = {
  SETTLED: 'Settled',
  OUTSTANDING: 'Outstanding',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
}

export const CLAIM_GRAPH_TYPES = {
  OUTSTANDING: 'OUTSTANDING',
  SETTLED: 'SETTLED',
  REJECTED: 'REJECTED',
}

export const EMPLOYEE_MANAGEMENT_HEADERS = [
  {
    id: 'empId',
    numeric: true,
    disablePadding: false,
    label: 'Emp Id',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Name',
    disableSorting: true,
  },
  {
    id: 'gender',
    numeric: false,
    disablePadding: false,
    label: 'Gender',
    disableSorting: true,
  },
  {
    id: 'relationType',
    numeric: false,
    disablePadding: false,
    label: 'Relation Type',
    disableSorting: true,
  },
  {
    id: 'dependents',
    numeric: true,
    disablePadding: false,
    label: 'Dependents',
    disableSorting: true,
  },
  {
    id: 'dateOfJoining',
    numeric: false,
    disablePadding: false,
    label: 'DOJ',
  },
  {
    id: 'dateOfLeaving',
    numeric: false,
    disablePadding: false,
    label: 'DOL',
  },
  {
    id: 'dob',
    numeric: false,
    disablePadding: false,
    label: 'DOB',
    disableSorting: true,
  },
  {
    id: 'ctc',
    numeric: true,
    disablePadding: false,
    label: 'CTC',
    disableSorting: true,
  },
  {
    id: 'city',
    numeric: false,
    disablePadding: false,
    label: 'City',
    disableSorting: true,
  },
  {
    id: 'mobile',
    numeric: true,
    disablePadding: false,
    label: 'Mobile',
    disableSorting: true,
  },
  {
    id: 'emailId',
    numeric: false,
    disablePadding: false,
    label: 'Email Id',
    disableSorting: true,
  },
  {
    id: 'gmc',
    numeric: false,
    disablePadding: false,
    label: 'GMC',
    disableSorting: true,
  },
  {
    id: 'gtl',
    numeric: false,
    disablePadding: false,
    label: 'GTL',
    disableSorting: true,
  },
  {
    id: 'gpa',
    numeric: false,
    disablePadding: false,
    label: 'GPA',
    disableSorting: true,
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    disableSorting: true,
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    disableSorting: true,
  },
]

export const GMC_LIST = [
  'Group OPD Health Insurance',
  'Group Critical Illness Insurance',
  'Group Health Insurance (Parents)',
  'Group Health Insurance',
  'Group Super Top Up Insurance',
  'Health Insurance',
  'Group OPD Health Insurance',
  'Group Top-up Insurance',
]

export const GPA_LIST = [
  'Janata Personal Accident Policy Insurance',
  'Group Personal Accident Insurance (GPA)',
]

export const GTL_LIST = [
  'Group Term Life Insurance',
  'Employees Deposit Linked Insurance Scheme (EDLI)',
]

export const PAGINATION_ROWS = [
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '20',
    label: '20',
  },
  {
    value: '25',
    label: '25',
  },
  {
    value: '50',
    label: '50',
  },
  {
    value: '100',
    label: '100',
  },
]

export const SXP_UPLOAD_POLICY_TYPE = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
}

export const EMPLOYEE_STATS_USER_TYPES = {
  REGISTERED: 'REGISTERED',
  LOGGED_IN: 'LOGGED_IN',
  NON_LOGGED: 'NON_LOGGED',
}

export const EXPIRY_TYPES = {
  EXPIRED: 'EXPIRED',
  EXPIRING: 'EXPIRING',
  NONE: 'NONE',
}

export const EMPLOYEE_BENEFIT_POLICY_LIST = [
  'Group OPD Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
  'Health Insurance',
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Employees Deposit Linked Insurance Scheme (EDLI)',
  'Group Term Life Insurance',
  'Group Health Insurance',
  'Group Personal Accident Insurance (GPA)',
  'Janata Personal Accident Policy Insurance',
  'Individual Personal Accident',
]

export const CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS = {
  VIEW_TRANSACTION_HISTORY: 'VIEW_TRANSACTION_HISTORY',
  CD_BALANCE_CALCULATOR: 'CD_BALANCE_CALCULATOR',
  RECHARGE: 'RECHARGE',
}

export const CD_BALANCE_LINKED_POLICIES_TYPE_LABELS = {
  VIEW_TRANSACTION_HISTORY: 'View Transaction History',
  CD_BALANCE_CALCULATOR: 'CD Balance Calculator',
  RECHARGE: 'Recharge',
}

export const CD_BALANCE_LINKED_POLICIES_TABS = [
  {
    image: Transaction,
    label: CD_BALANCE_LINKED_POLICIES_TYPE_LABELS.VIEW_TRANSACTION_HISTORY,
    value: CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.VIEW_TRANSACTION_HISTORY,
  },
  {
    image: Calculator,
    label: CD_BALANCE_LINKED_POLICIES_TYPE_LABELS.CD_BALANCE_CALCULATOR,
    value: CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.CD_BALANCE_CALCULATOR,
  },
  {
    image: Request,
    label: CD_BALANCE_LINKED_POLICIES_TYPE_LABELS.RECHARGE,
    value: CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.RECHARGE,
  },
]

export const FULLSCREEN_TOGGGLE_TEXT = {
  FULL_SCREEN: 'Best viewed in fullscreen',
  EXIT_FULL_SCREEN: 'Exit Full Screen',
}

export const BUY_POLICY_ANIMATION =
  'https://paisaplan.s3.ap-south-1.amazonaws.com/public/animations/buyPolicy/health/data.html'

export const GROUP_HEALTH_INSURANCE_LIST = [
  'Health Insurance',
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Group OPD Health Insurance',
  'Group Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
]

export const HEALTH_PERSONAL_INSURANCE_LIST = [
  'Super Top Up Insurance',
  'Top Up Insurance',
  'Individual OPD Health Insurance',
  'Critical Illness Insurance',
]

export const PERSONAL_INSURANCE_LIST = [
  'Employees Deposit Linked Insurance Scheme (EDLI)',
  'Group Term Life Insurance',
  'Janata Personal Accident Policy Insurance',
  'Group Personal Accident Insurance (GPA)',
]

export const MOTOR_PERSONAL_INSURANCE = [
  'Motor Insurance',
  'Fire Insurance',
  'Marine Insurance',
  'Engineering Insurance',
  'Liability Insurance',
  'Travel Insurance',
  'Accessories Insurance',
  'Miscellaneous',
]

export const POLICY_TYPE_ALL = 'all'

export const YEARS = [2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017]

export const MONTHS = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
]

export const VERIFICATION_PENDING_TABS_TEXT = {
  VERIFICATION_PENDING_TEXT: 'Verification Pending',
  RENEWED_TEXT: 'Renewed Policy Under Digitalizing',
  DEFAULT_TEXT: 'Trovity is Digitalising Your ',
}

export const INSURANCE_TYPE_LIST = {
  MOTOR_INSURANCE: 'Motor Insurance',
  HEALTH_INSURANCE: 'Health Insurance',
  MOTOR_TWO_WHEELER_INSURANCE: 'Two-Wheeler',
  MOTOR_FOUR_WHEELER_INSURANCE: 'Four-Wheeler',
  LIFE_INSURANCE: 'Term Life Insurance',
}

export const INSURANCE_POLICIES_LIST = {
  STANDARD_FIRE_AND_SPECIAL_PERILS: 'Standard Fire and Special Perils (SFSP)',
  FIRE_LOSS_OF_PROFIT: 'Fire Loss of Profit (FLOP)',
  INDUSTRIAL_ALL_RISK: 'Industrial All Risk Insurance (IAR)',
  MEGA_RISK: 'Mega Risk Insurance policy',
  STAND_ALONE_TERRORISM: 'Stand Alone Terrorism Policy (SAT)',
  BHARAT_GRUHA_RAKSHA: 'Bharat Gruha Raksha (BGR)',
  BHARAT_LAGHU_UDYAM_SURAKSHA: 'Bharat Laghu Udyam Suraksha (BLUS)',
  BHARAT_SOOKSHMA_UDYAM_SURAKSHA: 'Bharat Sookshma Udyam Suraksha (BSUS)',
  HOME_PACKAGE: 'Home Package Insurance',
  BUSINESS_PACKAGE: 'Business Package Insurance',
  JEWELLERS_BLOCK: 'Jewellers Block Insurance',
  OFFICE_PACKAGE: 'Office Package Insurance',
  SHOPKEEPERS: 'Shopkeepers Insurance',
  BURGLARY: 'Burglary Insurance',
  MONEY: 'Money Insurance',
  FIDELITY: 'Fidelity Insurance',
  BAGGAGE: 'Baggage Insurance',
  ALL_RISK: 'All Risk Insurance',
  NEON_SIGN: 'Neon Sign Insurance',
  PLATE_GLASS: 'Plate Glass Insurance',
  PET: 'Pet Insurance',
  FILM: 'Film Insurance',
  SPECIAL_CONTINGENCY: 'Special Contingency',
  CAR: 'Car Insurance',
  TWO_WHEELER_BIKE: 'Two Wheeler / Bike Insurance',
  COMMERCIAL_VEHICLE: 'Commercial Vehicle Insurance',
  MISCELLANEOUS_VEHICLE: 'Miscellaneous Vehicle Insurance',
  TAXI_CAB: 'Taxi / Cab Insurance',
  AUTO_RICKSHAW: 'Auto Rickshaw Insurance',
  TRUCK: 'Truck Insurance',
  CONTRACTORS_ALL_RISK: 'Contractors All Risk Insurance',
  ERECTION_ALL_RISK: 'Erection All Risk Insurance',
  ADVANCED_LOSS_OF_PROFIT: 'Advanced Loss of Profit Insurance',
  MACHINERY_BREAKDOWN: 'Machinery Breakdown Insurance',
  ELECTRONIC_EQUIPMENT: 'Electronic Equipment Insurance',
  CONTRACTORS_PLANT_MACHINERY: 'Contractors Plant & Machinery Insurance',
  BOILER_PRESSURE_PLANT: 'Boiler and Pressure Plant Insurance',
  DETERIORATION_OF_STOCKS: 'Deterioration of Stocks',
  CIVIL_ENGINEERING_COMPLETE_RISK: 'Civil Engineering Complete Risk',
  HEALTH: 'Health Insurance',
  GROUP_SUPER_TOP_UP: 'Group Super Top Up Insurance',
  GROUP_TOP_UP: 'Group Top-up Insurance',
  SUPER_TOP_UP: 'Super Top Up Insurance',
  TOP_UP: 'Top Up Insurance',
  GROUP_OPD_HEALTH: 'Group OPD Health Insurance',
  INDIVIDUAL_OPD_HEALTH: 'Individual OPD Health Insurance',
  GROUP_HEALTH: 'Group Health Insurance',
  GROUP_HEALTH_PARENTS: 'Group Health Insurance (Parents)',
  GROUP_CRITICAL_ILLNESS: 'Group Critical Illness Insurance',
  CRITICAL_ILLNESS: 'Critical Illness Insurance',
  GROUP_PERSONAL_ACCIDENT: 'Group Personal Accident Insurance (GPA)',
  JANATA_PERSONAL_ACCIDENT: 'Janata Personal Accident Policy Insurance',
  EMPLOYEES_DEPOSIT_LINKED_INSURANCE:
    'Employees Deposit Linked Insurance Scheme (EDLI)',
  INDIVIDUAL_PERSONAL_ACCIDENT: 'Individual Personal Accident',
  GROUP_TERM_LIFE: 'Group Term Life Insurance',
  OVERSEAS_TRAVEL: 'Overseas Travel Insurance Policy',
  OVERSEAS_MEDICLAIM: 'Overseas Mediclaim Insurance',
  DIRECTORS_OFFICERS: 'Directors & Officers Insurance',
  COMMERCIAL_GENERAL_LIABILITY: 'Commercial General Liability (CGL)',
  PUBLIC_LIABILITY: 'Public Liability (PL)',
  PL_ACT: 'PL Act',
  ERRORS_OMISSIONS: 'Errors & Omission Insurance',
  WORKMEN_COMPENSATION: 'Workmen Compensation (WC)',
  CYBER_LIABILITY: 'Cyber Liability',
  CLINICAL_TRIAL: 'Clinical Trial Insurance',
  CRIME: 'Crime Insurance',
  MULTIMODAL_TRANSPORT_LIABILITY:
    'Multimodal Transport Operators Liability Insurance',
  CARRIERS_LEGAL_LIABILITY: 'Carriers Legal Liability',
  MARINE_SPECIFIC_VOYAGE: 'Marine Specific Voyage Insurance Policy',
  MARINE_OPEN_POLICY: 'Marine Open Policy',
  MARINE_OPEN_COVER: 'Marine Open Cover',
  MARINE_STOP: 'Marine STOP',
  MARINE_HULL: 'Marine Hull Insurance',
  DELAY_IN_START_UP: 'Delay in Start-up (DSU)',
  PROFESSIONAL_INDEMNITY: 'Professional Indemnity Insurance (PI)',
  LIFE_INSURANCE: 'Life Insurance',
  INSURANCE: 'Insurance',
}

export const INSURANCE_CATEGORIES = {
  HEALTH: 'health',
  BIKE: 'bike',
  MOTOR: 'motor',
  MARINE: 'marine',
}

export const FINAL_ITEM = {
  CLAIMS: 'claims',
  REM_DAYS: 'remDays',
  ORANGE: 'orange',
}

export const POLICY_STATE = {
  NONE: 'None',
  BLOCK: 'block',
}

export const TYPE_OF_UPLOAD = {
  UP_TYPE: 'upload',
  DOWN_TYPE: 'claim',
  RENEW_TYPE: 'renew',
}

export const UPLOAD_POLICY = 'UPLOAD POLICY'

export const ERROR_MESSAGES = {
  ERR_0001: 'internal server error',
  ERR_0002: 'RECORD NOT FOUND!',
  ERR_0003: 'MODIFICATION_NOT_POSSIBLE',
  ERR_0004: 'MODIFICATION_NOT_POSSIBLE',
  ERR_0005: 'FORBIDDEN_POLICY',
  ERR_0007: 'PARSING_NOT_POSSIBLE',
  ERR_0008: 'UPLOADING_NOT_POSSIBLE',
}

export const SUCCESSFULLY_UPDATED = 'Successfully updated'

export const INPUT_FOCUS_KEYS = {
  Delete: 'Delete',
  Backspace: 'Backspace',
}

export const membersColumns = ['Name', 'Age', 'Relation']
export const membersColumnsCEO = ['Id', 'Name', 'Age', 'Relation']

export const PLEASE_WAIT_WHILE_FETCHING =
  'Please wait while fetching the data ...'

export const NO_DATA = 'No data available'

export const CUSTOM_PAGINATION_TITLE =
  'Includes Active, Deleted, Add-requested, Deletion-requested'

export const COVERAGE_HEADING = {
  policyCoverages: 'Policy Coverages',
  individualCoverages: 'Individual Policy Coverages',
}

export const menuOptionsClaims = [
  {
    label: 'Financial Claims',
    type: 'FINANCIAL_CLAIMS_VIEW',
  },
  {
    label: 'Pending Claims',
    type: 'PENDING_CLAIMS_VIEW',
  },
]

export const CLAIMS_VIEW_TABS = {
  FINANCIAL_CLAIMS_VIEW: 'FINANCIAL_CLAIMS_VIEW',
  PENDING_CLAIMS_VIEW: 'PENDING_CLAIMS_VIEW',
}

export const menuOptionsPremiumAndClaims = [
  {
    label: 'Financial Premium & Claims',
    type: 'FINANCIAL_PREMIUM_AND_CLAIMS_VIEW',
  },
  {
    label: 'Premium & Claims',
    type: 'PREMIUM_AND_CLAIMS_VIEW',
  },
]

export const PREMIUM_AND_CLAIMS_VIEW_TABS = {
  FINANCIAL_PREMIUM_AND_CLAIMS_VIEW: 'FINANCIAL_PREMIUM_AND_CLAIMS_VIEW',
  PREMIUM_AND_CLAIMS_VIEW: 'PREMIUM_AND_CLAIMS_VIEW',
}

export const CLAIMS_GRAPH_VIEW_TABS = {
  FINANCIAL: 'financial',
  PENDING: 'pending',
  PREMIUM: 'premium',
}
